<template>
  <nx-dialog
    :visible.sync="show"
    :title="title+'详情'"
    width="1300px"
    :before-close="beforeClose"
    :cancel-text="false"
    :confirm-text="false"
    @onConfirm="$emit('update:visible', false)"
  >
    <!-- 根据基础数据类型不同来决定详情的内容 -->
    <!-- CAN矩阵 -->
    <nx-table
      v-show="config && config.dataType == 0"
      ref="nxTable1"
      :data="tableData"
      style="padding: 0;"
      :operation="false"
      @search="search"
    >
      <el-table-column label="变量名(英文名)" prop="varName" width="140"></el-table-column>
      <el-table-column label="中文名" prop="cnName" width="200"></el-table-column>
      <el-table-column label="数据类型" prop="dataType"></el-table-column>
      <el-table-column label="CANID" prop="canid" width="130"></el-table-column>
      <el-table-column label="排列方式" prop="sortMode">
        <template slot-scope="{row}">
          {{ (sortModeTypes.find((item) => item.value === Number(row.sortMode)) || {}).label }}
        </template>
      </el-table-column>
      <el-table-column label="起始字节" prop="startByte"></el-table-column>
      <el-table-column label="起始比特" prop="startBit"></el-table-column>
      <el-table-column label="位长" prop="bitLength"></el-table-column>
      <el-table-column label="比例/bit(系数)" prop="ratio" width="130"></el-table-column>
      <el-table-column label="偏移量" prop="offset"></el-table-column>
      <el-table-column label="单位" prop="unit"></el-table-column>
      <el-table-column label="最小值" prop="minValue"></el-table-column>
      <el-table-column label="最大值" prop="maxValue"></el-table-column>
      <el-table-column label="枚举值说明" prop="enumDesc"></el-table-column>
    </nx-table>
    <!-- 故障字典 -->
    <nx-table
      v-show="config && config.dataType == 1"
      ref="nxTable2"
      :data="tableData"
      style="padding: 0;"
      :operation="false"
      @search="search"
    >
      <el-table-column label="DTC Code" prop="dtcCode"></el-table-column>
      <el-table-column label="ECU" prop="ecu"></el-table-column>
      <el-table-column label="SPN" prop="spn"></el-table-column>
      <el-table-column label="FMI" prop="fmi"></el-table-column>
      <el-table-column label="故障等级" prop="faultLevel"></el-table-column>
      <el-table-column label="仪表盘故障指示" prop="faultIns"></el-table-column>
      <el-table-column label="是否安抛类故障" prop="throwFault"></el-table-column>
      <el-table-column label="故障说明" prop="faultDesc"></el-table-column>
      <el-table-column label="故障原因" prop="faultReason"></el-table-column>
      <el-table-column label="建议处理方式" prop="method"></el-table-column>
    </nx-table>
  </nx-dialog>
</template>
<script>
import { getDetail } from '@/api/dataService/base.js';
import { sortModeTypes } from '../../config.js';
export default {
  props: {
    visible: {
      type: Boolean
    },
    config: {
      type: [Object, String],
      default: () => ''
    }
  },
  data() {
    return {
      sortModeTypes,
      show: false,
      tableData: [],
      title: ''
    };
  },
  computed: {},
  watch: {
    visible: {
      handler(visible) {
        this.show = visible;
        if (!visible) return;
        this.title = this.config.dataType === 0 ? 'CAN矩阵' : '故障字典';
        this.$nextTick(() => {
          if (this.config.dataType === 0) {
            this.$refs.nxTable1.search(1);
          }
          else {
            this.$refs.nxTable2.search(1);
          }
        });
      }
    },
    show: {
      handler(show) {
        this.$emit('update:visible', show);
      }
    }
  },
  created() {
  },
  mounted() {

  },
  methods: {
    async search(pagination) {
      if (!this.config.id) {
        return;
      }
      const { pageNum, pageSize } = pagination;
      const params = {
        baseId: this.config.id,
        pageNum,
        pageSize
      };
      const { data } = await getDetail(this.config.dataType, params);
      this.tableData = data.list;
      pagination.total = data.total;
    },
    beforeClose(done) {
      done();
    }
  }
};
</script>
<style scoped lang="scss">
</style>
